module.exports = __webpack_public_path__ + "static/img/通@3x.02ef0ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/供应链金融/通@3x.png
// module id = bIie
// module chunks = 192